var _use, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 726,
    height: 885,
    viewBox: "-17.582 -4.664 71.571 87.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    stroke: "#003893",
    strokeWidth: 5.165
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-15 37.574h60L-15 0v80h60l-60-60z",
    fill: "#DC143C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-11.95 23.483a12.84 12.84 0 0 0 23.9 0 11.95 11.95 0 0 1-23.9 0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.045) scale(5.56106)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M.195-.98 0-1.39l-.195.408",
    transform: "rotate(11.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(22.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(67.5)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 58.787) scale(8.1434)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.259.966 0 1.576l-.259-.61"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "rotate(180)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "rotate(60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/np.2e647627e7ffc054de30d48e8b940a67.svg";
export { ForwardRef as ReactComponent };